import { ReportingConfig } from '@opengov/app-config-reporting';

export function getStandaloneAppAuth0Config() {
  return {
    domain: ReportingConfig.AUTH0_DOMAIN,
    clientId: ReportingConfig.AUTH0_CLIENT_ID,
    cacheLocation: 'localstorage' as const,
    authorizationParams: {
      redirect_uri: `${window.location.origin}/auth/users/callback`,
      scope: 'openid profile email'
    }
  };
}

type Auth0TokenError = Error & {
  error?: string;
  error_description?: string;
};

export function isAuth0TokenError(e: unknown): e is Auth0TokenError {
  return e instanceof Error && 'error' in e;
}
